var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AdvancementGui',{attrs:{"type":_vm.type,"color-map":_vm.colorMap}},[_c('img',{attrs:{"src":_vm.icon,"alt":_vm.advancementName}})])}
var staticRenderFns = []

export { render, staticRenderFns }